import { useEffect, useRef } from 'react';

export default function useDebounceEffect(
  fn: Function,
  delay: number,
  values: any,
  runOnInitialize = false,
) {
  const didMountRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (!runOnInitialize && !didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    const handler = setTimeout(() => {
      fn();
    }, delay);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, values);
}
